export const SELECT_STATE = 'components/AutoInput/select_state'
export const SELECT_LOCATION = 'components/AutoInput/select_location'
export const USER_DATA_VALID= 'components/AutoInput/user_data_valid'



// WEBPACK FOOTER //
// ./src/scenes/NewClient/constants.js